export default __webpack_public_path__ + "static/media/error401.0dd3fd5a.svg";